var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pager" },
    [
      _c(
        "yxt-pagination",
        _vm._b(
          {
            staticClass: "pull-right",
            attrs: {
              "simple-total": "",
              "current-page": _vm.currentPage,
              "page-size": _vm.pager.pageSize,
              layout: "total, prev, pager, next",
              total: _vm.pager.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
              "update:currentPage": function ($event) {
                _vm.currentPage = $event
              },
              "update:current-page": function ($event) {
                _vm.currentPage = $event
              },
            },
          },
          "yxt-pagination",
          _vm.pageOption,
          false
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }